<template>
  <div class="toolbardiv">
        <div class="toolbar">
            <div :class="{ inputtextDiv: true}" id="news_say_ipt">
                <span id="inputtext" class="input"><span class="icon i_input"></span> 说两句...</span>
            </div>
            <div class="tool_item">
                <span><i class="counts">{{ 0 || 0 }}</i> <i class="icon i_comment"></i></span>
            </div>
        </div>
        <div :class="{textareadiv: showText,none: !true}" ref="textareadiv" >
            <div class="textareapop">
                <div class="btndiv">
                    <span class="title">说两句</span>
                    <span class="cancel">取消</span>
                    <span class="send">发送</span>
                </div>
                <textarea ref="textarea" :placeholder="placeholder"  ></textarea>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "toolbar",
    data () {
        return {
            showText: false,
            placeholder: "请输入"
        }
    }
}
</script>
